import React from 'react';

import TypographyBox from '../TypographyBox/TypographyBox';

const Heading = ({ as, content, ellipsis, textTransform, ...props }) => {
  if (as === 'h2')
    return (
      <TypographyBox
        texttransform={textTransform}
        ellipsis={ellipsis}
        component="h2"
        mb={0}
        mt={0}
        fontSize="24px"
        fontWeight="600"
        lineHeight="1.5"
        {...props}
      >
        {content}
      </TypographyBox>
    );
  else if (as === 'h6')
    return (
      <TypographyBox
        texttransform={textTransform}
        ellipsis={ellipsis}
        component="h6"
        mb={0}
        mt={0}
        fontSize="13px"
        fontWeight="600"
        lineHeight="1.5"
      >
        {content}
      </TypographyBox>
    );

  return (
    <TypographyBox
      texttransform={textTransform}
      ellipsis={ellipsis}
      component="h1"
      mb={0}
      mt={0}
      fontSize="28px"
      fontWeight="600"
      lineHeight="1.5"
    >
      {content}
    </TypographyBox>
  );
};

export default Heading;
